<template>
  <VDialog v-model="showModal"
           :class="$style.modal"
           :max-width="maxWidth">
    <slot />
  </VDialog>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import HelpModal from '@/components/HelpModal';

/**
 * Kiosk modal.
 */
@Component({
  components: {
    HelpModal,
  },
  props: {
    show: {
      type:     Boolean,
      default:  false,
      required: true,
    },
    maxWidth: {
      type:     String,
      required: false,
    },
  },
})
export default class KioskModal extends Vue {
  /**
   * Show modal getter.
   */
  get showModal() {
    return this.show;
  }

  /**
   * Show modal setter.
   * @param {Boolean} value.
   */
  set showModal(value) {
    if (!value) {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';

.modal {
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskModal.vue